import React from 'react';
import './ReviewLocation.styl';
import {LocationDotIcon} from '@components/icon/LocationDotIcon';

export default ({review}) => (
  <div className="coaching-review-location">
    <LocationDotIcon tooltip="Location" />
    {(review.meetingType && review.meetingType.detail()) || 'Virtual meeting'}
  </div>
);
